import { AppDispatch } from "../../index";
import { canVerifyOperation } from "../operations";
import { auth } from "../../../common/auth";

export const canVerifyAction = async (phone: string, dispatch: AppDispatch) =>
    await canVerifyOperation.invoke(async () => {
        await auth.canVerify(phone);
        return true;
    }, dispatch);
